<template>
  <div class="boutons">
      <simple-bouton text="Voir login" destination="Gestion/VoirLogins"/>
      <simple-bouton text="Créer compte" destination="Gestion/CreationComptes"/>
      <simple-bouton text="Voir notes" destination="Gestion/VoirNotes"/>
  </div>
</template>

<script>
import SimpleBouton from '../../Bouton.vue'


export default {
    components: {
        SimpleBouton
    },
    
}
</script>

<style scoped>
    .boutons{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 60rem;
    }


</style>